import { ChangeDirection } from "constants/change-direction";

export function calculateChangeDirection(num: number): ChangeDirection {
  if (num === 0) {
    return ChangeDirection.NoChange;
  }
  return num > 0 ? ChangeDirection.Up : ChangeDirection.Down;
}
